import React from 'react';
import classnames from 'classnames';
import { message as antdMessage, MessageArgsProps as MessageProps } from 'antd';

import './style.scss';

const PREFIX = 'music';

type ConfigContent = React.ReactNode;
type ConfigDuration = number;
type ConfigOnClose = () => void;
type JointContent = ConfigContent | MessageProps;

interface MessageType extends PromiseLike<any> {
  (): void;
}

interface MessageInstance {
  info(content: JointContent, duration?: ConfigDuration, onClose?: ConfigOnClose): MessageType;
  success(content: JointContent, duration?: ConfigDuration, onClose?: ConfigOnClose): MessageType;
  error(content: JointContent, duration?: ConfigDuration, onClose?: ConfigOnClose): MessageType;
  warning(content: JointContent, duration?: ConfigDuration, onClose?: ConfigOnClose): MessageType;
  loading(content: JointContent, duration?: ConfigDuration, onClose?: ConfigOnClose): MessageType;
  open(args: MessageProps): MessageType;
}

const wrapMessageMethod = (method: (config: MessageProps) => MessageType, _type: string) => {
  return (content: any, duration?: ConfigDuration, onClose?: ConfigOnClose) => {
    let newConfig: MessageProps;

    if (typeof content === 'string' || React.isValidElement(content)) {
      newConfig = {
        content,
        duration,
        onClose,
        className: classnames(`${PREFIX}-message-wrapper`),
      };
    } else {
      newConfig = { ...content, className: classnames(`${PREFIX}-message-wrapper`, content.className) };
    }

    return method(newConfig);
  };
};

const message: MessageInstance = { ...antdMessage } as any;

message.open = wrapMessageMethod(antdMessage.open, '') as unknown as any;
['success', 'info', 'warning', 'error', 'loading'].forEach((type) => {
  (message as any)[type] = wrapMessageMethod((antdMessage as any)[type], type);
});

export default message;
